import { useEffect, useState } from "react";

function usePagination(fetchFn, { pageSize = 20, deps = [] }) {
    const [content, setContent] = useState([]);
    const [page, setPage] = useState(0);
    const [size, setSize] = useState(pageSize);
    const [totalPages, setTotalPages] = useState(0);
    const [totalElements, setTotalElements] = useState(0);

    const fetch = async (pageNum = page, pageSize = size) => {
        await fetchFn({
            page: pageNum,
            size: pageSize,
            onSuccess: (data) => {
                setContent(data?.content ?? []);
                setTotalPages(data?.totalPages ?? 0);
                setTotalElements(data?.totalElements ?? 0);
            },
            onError: (e) => console.error(e)
        });
    };

    const refresh = () => fetch(page, size);

    useEffect(() => {
        fetch(page, size);
    }, [page, size, ...deps]);

    return { content, page, setPage, size, setSize, totalPages, totalElements, refresh };
}

export default usePagination;